import { apiService } from "@/services";
import { settings } from "@/settings";
import { StepsClient } from "./GeneratedClients";

const stepRepository = new StepsClient(settings.webApi.baseUrl, apiService.getApiClient());

export { stepRepository };
